import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ReusableFunctions } from '../../classes/reusable-functions';
import { IDisplayOptionToReset, IOptionalSummaryList } from '../../interfaces/display-options';
import { ScheduledReportsService } from '../../services/scheduled-reports.service';
import { ToastService } from '../../services/toast.service';

@Component({
    selector: 'app-schedule-report-builder',
    templateUrl: './schedule-report-builder.component.html',
    styleUrls: ['./schedule-report-builder.component.css'],
})
export class ScheduleReportBuilderComponent implements OnInit {
    report: any;

    existingSchedules: any[];
    selectedSchedule: any;

    view: string = 'new';

    scheduleOptions: any;

    hFilterJson: string;

    scheduleValues = {
        when: 2,
        day: 0,
        monthly: 'first',
        hour: 12,
        scheduleName: '',
        utcOffset: 0,
    };

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private reusableFunctions: ReusableFunctions,
        private scheduledReportService: ScheduledReportsService,
        private dialogRef: MatDialogRef<ScheduleReportBuilderComponent>,
        private toastService: ToastService
    ) {}

    ngOnInit(): void {
        //console.log(this.data);

        this.scheduleOptions = this.scheduledReportService.getOptions();

        if (this.data) {
            this.report = this.data;

            this.data.hFilterJSON = [];

            if (this.data.routerParams) {
                let hFilter = this.data.routerParams.find((x) => x.title === 'hFilterJSON');
                if (hFilter) {
                    this.data.hFilterJSON = hFilter.value;
                }
            }
        }

        //this.getExisting();
        this.setUtcOffset();
    }

    create() {
        let data = {
            reportId: this.data.reportId,
            scheduleName: this.scheduleValues.scheduleName,
            frequency: this.scheduleValues.when,
            dayOfWeek: this.scheduleValues.day,
            dayOfMonth: this.scheduleValues.monthly,
            hour: this.scheduleValues.hour,
            filters: JSON.stringify(this.data.filters),
            utcOffset: this.scheduleValues.utcOffset,
            reportName: this.data.reportName,
            optionalSummaryList: JSON.stringify(this.data.optionalSummaryList),
            routerParams: JSON.stringify(this.data.routerParams),
            module: this.data.module,
            hFilterJSON: this.data.hFilterJSON,
        };

        this.scheduledReportService.createScheduledReport(data).subscribe(
            (res) => {
                //console.log(res);
                this.toastService.success('Your scheduled report has been created');
                this.dialogRef.close();
            },
            (error) => {
                this.toastService.warning('Something went wrong creating your scheduled report');
                this.dialogRef.close();
                //console.log(error);
            }
        );
    }

    getExisting() {
        this.scheduledReportService.getScheduledByReport(this.data.reportId).subscribe((res) => {
            //console.log('Existing scheduled: ', res);

            if (res) {
                this.existingSchedules = res;
            }
        });
    }

    setUtcOffset() {
        let utcOffsetMinutes = new Date().getTimezoneOffset();
        let utcOffset = 0;

        if (utcOffsetMinutes !== 0) {
            utcOffset = -(utcOffsetMinutes / 60);
        }

        this.scheduleValues.utcOffset = utcOffset;
    }

    selectExisting(schedule) {
        if (schedule) {
            this.scheduleValues = {
                when: schedule.when,
                day: schedule.day,
                monthly: schedule.monthly,
                hour: schedule.hour,
                scheduleName: schedule.scheduleName,
                utcOffset: 0,
            };

            this.setUtcOffset();

            this.report.optionalSummaryList = JSON.parse(schedule.optionalSummaryList);
            this.report.routerParams = JSON.parse(schedule.routerParams);
            //console.log(this.report);
            this.view = 'edit';
        }
    }

    applyDisplayOptions(e) {}
    applyNewFilters() {}
}
